export { default as ArrowRightAltIcon } from "@mui/icons-material/ArrowRightAlt";
